<template>
    <v-container class="max-container">
        <!--REDIRECT-PATH-->
            <v-row class="redrectrow">
                <v-col class="redrectrow__col1 no-pd-l" cols="1">
                    <v-skeleton-loader class="redrectrow__col1__text" type="text"/>
                </v-col>
                <span class="dividerBar" >/</span>
                <v-col class="redrectrow__col2" cols="2">
                    <v-skeleton-loader class="redrectrow__col2__text" type="text"/>
                </v-col>
            </v-row>
        <!--END-REDIRECT-PATH-->

        <!--PRIZE-DETAIL-->
            <v-row class="prizerow">
                <v-col class="prizerow__col1 no-pd-l" :cols=" hasResponsiveness ? '12' : '5' " >
                    <v-row class="prizerow__col1__row">
                        <v-col class="prizerow__col1__row__col1 no-pd-l" cols="5">
                            <v-skeleton-loader class="prizerow__col1__row__col1__title" type="image"/>
                        </v-col>
                        <v-col class="prizerow__col1__row__col2 no-pd-l" cols="3">
                            <v-skeleton-loader type="text"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="prizerow__col2" :cols="hasResponsiveness ? '12' : '7' ">
                    <v-row class="prizerow__col2__row">
                        <v-col class="prizerow__col2__row__col no-pd-l no-pd-r" cols="11">
                            <v-skeleton-loader class="prizerow__col2__row__col__cardprize" type="image"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        <!--END-PRIZE-DETAIL-->

        <!--RESCUE-INSTRUCTIONS-->
            <v-row class="rescueinstructionsrow">
                <v-col class="rescueinstructionsrow__col1" cols="4">
                    <v-row class="rescueinstructionsrow__col1__row">
                        <v-col class="rescueinstructionsrow__col1__row__col no-pd-l no-pd-r" cols="12">
                            <v-skeleton-loader class="rescueinstructionsrow__col1__row__col__title" type="image"/>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="rescueinstructionsrow__col2 no-pd-t" cols="6">
                    <v-row class="rescueinstructionsrow__col2__row">
                        <v-col class="no-pd-b no-pd-r no-pd-l" v-for="n in 3" :key="n" cols="4">
                            <v-row class="rescueinstructionrow__itens">
                                <v-col class="rescueinstructionrow__itens__colicon no-pd-b no-pd-t" cols="5">
                                    <v-skeleton-loader class="rescueinstructionrow__itens__colicon__icon" type="image"/>
                                </v-col>
                                <v-col cols="10">
                                    <v-skeleton-loader type="text"/>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        <!--END-RESCUE-INSTRUCTIONS-->

        <!--MORE-INFORMATION-->
            <v-row class="moreinformation__row">
                <v-col v-for="n in 2" :key="n" class="moreinformation__row__col" cols="2">
                    <v-skeleton-loader class="moreinformation__row__col__btn" type="image"/>
                </v-col>
            </v-row>
        <!--END-MORE-INFORMATION-->
    </v-container>
</template>

<script>
export default {
    name: 'rewardDetailLoader',
    data: () => ({
        hasResponsiveness: false
    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        compareWidth() {
            window.innerWidth <= 959 ? this.hasResponsiveness = true : this.hasResponsiveness = false;
        }
    }
}
</script>

<style scoped>
::v-deep .v-skeleton-loader__image {
    height: 100%;
}
/*REDIRECT-PATH*/
    .redrectrow {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
    .redrectrow__col1 {
        min-width: 96.75px;
    }
    .dividerBar { 
        padding-top: 6px;
        color: rgba(0, 0, 0, 0.38);
    }
    .redrectrow__col2 {
        min-width: 169.5px;
    }
/*END-REDIRECT-PATH*/

/*PRIZE-DETAIL*/
    .prizerow {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
    .prizerow__col1__row {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .prizerow__col1__row__col1 {
        min-width: 196.56px;
        max-width: 196.56px;
    }
    .prizerow__col1__row__col2 {
        min-width: 117.94px;
        max-width: 117.94px;
    }
    .prizerow__col1__row__col1__title {
        height: 28px;
        border-radius: 16px;
    }
    .prizerow__col2__row {
        display: flex;
        flex: auto !important;
        justify-content: center;
        height: 100%;
    }
    .prizerow__col2__row__col {
        min-width: 598.81px;
    }
    .prizerow__col2__row__col__cardprize {
        height: 302px;
        border-radius: 14px;
    }
/*END-PRIZE-DETAIL*/

/*RESCUE-INSTRUCTIONS*/
    .rescueinstructionsrow {
        display: flex;
        flex: auto !important;
        flex-direction: column;
        align-items: center;
    }
    .rescueinstructionsrow__col1 {
        min-width: 387px;
    }
    .rescueinstructionsrow__col2 {
        min-width: 580.5px;
    }
    .rescueinstructionsrow__col1__row {
        display: flex;      
        flex: auto !important;
    }
    .rescueinstructionsrow__col1__row__col__title {
        height: 28px;
        border-radius: 16px;
    }
    .rescueinstructionsrow__col1 {
        min-width: 387px;
    }
    .rescueinstructionsrow__col2 {
        min-width: 580.5px;
    }
    .rescueinstructionsrow__col2__row {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
    .rescueinstructionrow__itens {
        display: flex;
        flex: auto !important;
        flex-direction: column;
        align-items: center;
    }
    .rescueinstructionrow__itens__colicon__icon {
        height: 37px;
        width: 47px;
    }
/*END-RESCUE-INSTRUCTIONS*/

/*MORE-INFORMATION*/
    .moreinformation__row {
        display: flex;
        flex: auto !important;
        flex-direction: row;
        justify-content: center;
    }
    .moreinformation__row__col {
        min-width: 193px;
        padding-top: 32px;
    }
    .moreinformation__row__col__btn {
        width: 162px;
        height: 38px;
        border-radius: 22px;
    }
/*END-MORE-INFORMATION*/

/*RESPONSIVENESS*/
    @media(max-width: 956px) {
        .prizerow {
            flex-direction: column;
            align-content: center;
        }
        .prizerow__col1__row {
            align-content: center;
        }
        .prizerow__col2__row {
            align-content: center;
        }
        .prizerow__col2__row__col {
            max-width: 598.81px !important;
            min-width: 60%;
        }
        .rescueinstructionrow__itens__colicon__icon {
            min-width: 50%;
        }
        .rescueinstructionsrow__col1 {
            min-width: 60% !important;
        }
        .rescueinstructionsrow__col2 {
            min-width: 100% !important;
        }
        .moreinformation__row__col {
            min-width: 50%;
        }
        .moreinformation__row__col__btn {
            width: 90%;
        }
    }
/*END-RESPONSIVENESS*/
</style>